<button type="button" class="btn btn-sm btn-info" (click)="showPopup()"><span
    class="glyphicon glyphicon-th-list"></span> {{label}}</button>

<dx-popup class="popup" [height]="'80%'" [width]="'80%'" title="Erlaubnis" [showTitle]="true" [(visible)]="popupVisible"
  style="display: inline-block;">

  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView id="scrollview" [scrollByContent]="false" [scrollByThumb]="false"
      [showScrollbar]="'onHover'" reachBottomText="Updating...">
      <div style="padding-right: 15px;">
        <cz-erl *ngIf="popupVisible" (onCloseOk)="onCloseOkEvent($event)" [isErsdtAntrag]="isErsdtAntrag" [eId]="eId"
          [optional]="optional" [events]="eventsSubject.asObservable()"></cz-erl>
      </div>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
            text: 'Übernehmen',
            onClick: save
        }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
            text: 'Schließen',
            onClick: closePopup
        }">
  </dxi-popup-toolbar-item>

</dx-popup>